import { Loading3QuartersOutlined, ReloadOutlined, WarningFilled } from "@ant-design/icons";

export default function Something({ refetch, isFetching }: any) {
  return (
    <div className="flex justify-center items-center border">
      <div className="flex flex-col items-center my-20">
        <div className="flex items-center">
          <WarningFilled size={40} color="#9ca3af" />
        </div>
        <div className="text-gray-400">Something went wrong</div>
        <button
          onClick={() => refetch()}
          className="flex items-center  px-6 py-1 pt-1 mt-2 bg-autoinc text-white rounded-md"
        >
          <div className="">{isFetching ? <Loading3QuartersOutlined /> : <ReloadOutlined />}</div>
          <span className="ml-1">Retry</span>
        </button>
      </div>
    </div>
  );
}
